export const getEnergia = (state) => state.energia.lista
export const getTotalEnergia = (state) => state.energia.total
export const getIsCarregandoListaEnergia = (state) => state.energia.isCarregandoLista
export const getEnergiaSelecionado = (state) => state.energia.selecionado
export const getIsCarregandoEnergia = (state) => state.energia.isCarregandoEnergia
export const getIsSavingEnergia = (state) => state.energia.isSaving
